import SearchParamsBase from '../../../Elements/SearchParamsBase';
import CreditMemoStatusOptionsArray from '../../../Enums/CreditMemoStatusOptionsArray';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import UserService from '../../../Services/userService';

export default class TpCreditMemoSearchParams extends SearchParamsBase {
  static saveType = 'TpCreditMemoSearchParams';
  initialize() {
    this.SelectedOfficeIds = OfficeHelper.GetDefaultOfficeIds(parseInt(UserService.GetOfficeIdOfLoggedInUser()));
    this.ClientNameOrId = '';
    this.TpCreditMemoId = '';
    this.TpClientInvoiceId = '';
    this.CreatedBy = '';
    this.AssignedTo = '';
    this.SelectedStatuses = [];
  }

  static fieldsInSearchBox = [
    { fieldName: 'TpCreditMemoId', label: 'Credit Memo ID', className: 'col-6', type: InputTypesEnum.Text },
    { fieldName: 'TpClientInvoiceId', label: 'Client Invoice ID', className: 'col-6', type: InputTypesEnum.Number },
    { fieldName: 'ClientNameOrId', label: 'Client Name Or ID', className: 'col-6', type: InputTypesEnum.Text },
    {
      fieldName: 'SelectedOfficeIds',
      label: 'Office',
      className: 'col-6',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    { fieldName: 'AssignedTo', label: 'Assigned To', className: 'col-6', type: InputTypesEnum.UserSelect },
    { fieldName: 'CreatedBy', label: 'Created By', className: 'col-6', type: InputTypesEnum.UserSelect },
    {
      fieldName: 'SelectedStatuses',
      label: 'Status',
      className: 'col-6',
      type: InputTypesEnum.MultiChoice,
      options: CreditMemoStatusOptionsArray,
    },
  ];
}
